import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MonitoredTrain } from '../../models/monitored-train';

@Component({
  selector: 'app-monitored-train-info',
  template: require('./monitored-train-info.component.html'),
  styles: [require('./monitored-train-info.component.sass')]
})
export class MonitoredTrainInfoComponent implements OnInit {

  @Input() train: MonitoredTrain;

  @Output() investigateTrain = new EventEmitter<MonitoredTrain>();

  constructor() { }

  ngOnInit(): void {
  }

  onInvestigateTrain = () => {
    this.investigateTrain.emit(this.train);
  };
}
